import type { SubscriptionPeriodicity } from "@arbeidsark/shared"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import styled from "styled-components"
import { useTranslate } from "~/ur-react-hooks"
import { useSubscriptionInfo } from "../../../utils/hooks/useSubscriptionInfo"
import { useToast } from "../../../utils/hooks/useToast"
import { trpc } from "../../../utils/trpc"
import SelectSubscription from "./SelectSubscription"
const Layout = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
`

const Card = styled.div`
  background: white;
  box-shadow: ${(props) => props.theme.shadow.elevation3};

  padding: 2rem 1.5rem;

  border-radius: 8px;

  width: 378px;
`

export type ChangePeriodicityProps = {}

const ChangePeriodicity: React.FC<ChangePeriodicityProps> = () => {
  const subscription = useSubscriptionInfo()!
  const [periodicity, setPeriodicity] = useState<SubscriptionPeriodicity>(
    subscription.periodicity,
  )

  const translations = useTranslate({
    save: "common.save",
    success: "change-periodicity.save-success",
    cancel: "common.cancel",
  })

  const toast = useToast()
  const trpcContext = trpc.useContext()
  const navigate = useNavigate()

  const { mutate: changePeriodicity, isPending: isLoading } =
    trpc.subscriptions.changeUserSubscriptionPeriodicity.useMutation({
      onSuccess() {
        toast("success", translations.success)
        trpcContext.users.me.invalidate()
        navigate("/subscription")
      },
    })

  return (
    <Layout>
      <Card>
        <SelectSubscription
          value={periodicity}
          onChange={setPeriodicity}
          onNext={() => {
            if (periodicity === subscription.periodicity) {
              navigate("/subscription")
              return
            }

            changePeriodicity(periodicity)
          }}
          buttonText={
            periodicity === subscription.periodicity
              ? translations.cancel
              : translations.save
          }
          isLoading={isLoading}
          currentSubscription={subscription.periodicity}
          buttonType={
            periodicity === subscription.periodicity ? "outline" : "regular"
          }
        />
      </Card>
    </Layout>
  )
}

export default ChangePeriodicity
